"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartActionSchemaProperties = exports.SmartActionTemplateSchema = exports.SmartActionTemplateEventSchema = exports.SmartActionTemplateWhenSchema = exports.SmartActionSchema = exports.SmartActionActionSchema = exports.SmartActionActionMethodEnum = exports.SmartActionActionArtifactEnum = exports.SmartActionActionTypeEnum = exports.SmartActionEventSchema = exports.SmartActionEventTypeEnum = exports.SmartActionTriggerEnum = exports.SmartActionTimingEnum = exports.SmartActionStatusEnum = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.SmartActionStatusEnum = zod_1.z.enum([
    "pending",
    "completed",
    "processing",
    "deleted",
    "failed",
    "paused",
]);
exports.SmartActionTimingEnum = zod_1.z.enum([
    "immediately",
    "before",
    "after",
    "onDate",
    "count",
]);
exports.SmartActionTriggerEnum = zod_1.z.enum([
    "appointment-is-booked",
    "appointment-starts",
    "appointment-ends",
    "appointment-outcome-updated",
    "form-is-submitted",
    "send-form-reminder",
    "payment-is-completed",
    "package-is-booked",
    "package-is-assigned",
    "package-sessions-completed",
    "product-is-purchased",
    "invoice-send-date",
    "package-instance-is-created",
    "package-instance-recurring-due",
    "package-instance-ended",
    "package-instance-payment-collected",
    "event-is-booked",
    "event-starts",
    "event-ends",
    "invoice-is-due",
    "subscription-trial-will-end",
    "todo-assignment",
    "todo-due-date",
    "billing-transaction-computed",
    "package-tracking-status-changed",
    "package-is-at-risk",
    "package-is-off-track",
    "invoice-updated-on-stripe",
    "subscription-updated-on-stripe",
    "product-updated-on-stripe",
    "price-updated-on-stripe",
    "package-template-created",
    "package-template-updated",
    "none",
    "invoice-paid",
    "setup-intent-requires-action",
    "payment-intent-processing",
    "package-instance-updated",
    "package-instance-subscription-updated",
]);
exports.SmartActionEventTypeEnum = zod_1.z.enum([
    "appointment",
    "form",
    "package",
    "invoice",
    "packageInstance",
    "subscriptions",
    "todo",
    "stripe-products",
    "stripe-prices",
    "stripe-subscriptions",
]);
exports.SmartActionEventSchema = zod_1.z.object({
    timming: exports.SmartActionTimingEnum,
    trigger: exports.SmartActionTriggerEnum,
    resourceId: zod_1.z.string().optional().nullable(),
    type: exports.SmartActionEventTypeEnum.optional(),
    settings: zod_1.z
        .object({
        acceptedOutcomes: zod_1.z.string().array().optional(),
        appointmentCount: zod_1.z.number().optional(),
    })
        .optional(),
    customType: zod_1.z.string().optional(),
});
exports.SmartActionActionTypeEnum = zod_1.z.enum([
    "add-label",
    "send-form",
    "send-form-with-signed-contract",
    "show-form",
    "send-reminder",
    "send-library-item",
    "send-invoice",
    "bill-scheduled-invoice",
    "send-bill-invoice-notification",
    "send-invoice-reminder-coach",
    "send-invoice-reminder-client",
    "send-trial-will-end-reminder",
    "todo-assignment-reminder",
    "todo-due-date-reminder",
    "todo-week-reminder",
    "recurring-package-instance",
    "complete-package-instance",
    "create-billable-request",
    "rollover-pending-transactions",
    "add-billing-transaction-to-ap-invoice",
    "add-billing-transaction-to-ubp-invoice",
    "recompute-billing-transaction",
    "collect-package-payment",
    "send-form-reminder",
    "send-package-tracking-notification",
    "check-package-tracking-status",
    "sync-invoice",
    "sync-subscription",
    "create-package-instance-subscription",
    "expire-package-instance",
    "call-endpoint",
    "activate-package-instance",
    "sync-invoice-with-quick-books",
    "update-package-instance-tier",
]);
exports.SmartActionActionArtifactEnum = zod_1.z.enum([
    "labels",
    "forms",
    "files",
    "folders",
    "links",
    "invoices",
    "packages",
    "packageInstances",
    "subscriptions",
    "accounts",
    "clients",
    "appointments",
    "stripe-subscriptions",
    "stripe-products",
]);
exports.SmartActionActionMethodEnum = zod_1.z.enum([
    "to-client-record",
    "via-email",
    "during-book-flow",
    "via-sms",
    "via-email-via-sms",
    "via-sms-via-email",
]);
exports.SmartActionActionSchema = zod_1.z.object({
    type: exports.SmartActionActionTypeEnum,
    artifactType: exports.SmartActionActionArtifactEnum.optional(),
    resourceId: zod_1.z.string().optional().nullable(),
    method: exports.SmartActionActionMethodEnum.optional(),
    settings: zod_1.z
        .object({
        billingRateId: zod_1.z.string().optional(),
        duration: zod_1.z.number().optional(),
        allowCreate: zod_1.z.boolean().optional(),
        realmId: zod_1.z.string().optional(),
        priceId: zod_1.z.string().optional(),
    })
        .optional(),
    data: zod_1.z.object({}).partial().passthrough().optional(),
});
exports.SmartActionSchema = base_schema_1.BaseSchema.extend({
    clientId: zod_1.z.string().optional(),
    coachId: zod_1.z.string(),
    status: exports.SmartActionStatusEnum,
    when: zod_1.z.date().optional(),
    event: exports.SmartActionEventSchema,
    action: exports.SmartActionActionSchema,
    apiPath: zod_1.z.string().optional(),
    useApi: zod_1.z.boolean().optional(),
    orderingKey: zod_1.z.string().optional(),
    retries: zod_1.z
        .object({
        retryDate: zod_1.z.date().optional(),
        lastError: zod_1.z.string().optional(),
        lastErrorDate: zod_1.z.date().optional(),
    })
        .array()
        .optional(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.SmartActionTemplateWhenSchema = zod_1.z.object({
    value: zod_1.z.number().or(zod_1.z.string()),
    type: zod_1.z.enum(["hours", "days"]),
});
exports.SmartActionTemplateEventSchema = exports.SmartActionEventSchema.extend({
    when: exports.SmartActionTemplateWhenSchema.optional(),
});
exports.SmartActionTemplateSchema = zod_1.z.object({
    action: exports.SmartActionActionSchema,
    event: exports.SmartActionTemplateEventSchema,
});
exports.SmartActionSchemaProperties = {
    collectionName: "smartActions",
    deleteMode: schema_properties_interface_1.DeleteMode.Hard,
};
//# sourceMappingURL=smart-action-schema.js.map